import { useId } from 'react';

import { cn } from '@/lib/utils';

interface InstagramIconProps {
    className?: string;
}

export function InstagramIcon({ className }: InstagramIconProps) {
    const id = useId();
    const clipPathId = `${id}-clip0`;
    const outerGradientId = `${id}-paint0-linear`;
    const innerGradientId = `${id}-paint1-linear`;
    const dotGradientId = `${id}-paint2-linear`;

    return (
        <svg
            viewBox='0 0 40 40'
            aria-hidden='true'
            className={cn('h-5 w-5 shrink-0', className)}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d='M28.0838 0L11.9162 0C5.34559 0 0 5.34559 0 11.9162L0 28.0838C0 34.6544 5.34559 40 11.9162 40L28.0838 40C34.6544 40 40 34.6544 40 28.0838L40 11.9162C39.9999 5.34559 34.6543 0 28.0838 0ZM35.976 28.0838C35.976 32.4425 32.4425 35.976 28.0838 35.976L11.9162 35.976C7.5575 35.976 4.024 32.4425 4.024 28.0838L4.024 11.9162C4.024 7.55743 7.5575 4.024 11.9162 4.024L28.0838 4.024C32.4425 4.024 35.976 7.55743 35.976 11.9162L35.976 28.0838Z'
                    fill={`url(#${outerGradientId})`}
                />
                <path
                    d='M20.0002 9.6532C14.2957 9.6532 9.65479 14.2941 9.65479 19.9985C9.65479 25.7029 14.2957 30.344 20.0002 30.344C25.7047 30.344 30.3456 25.703 30.3456 19.9985C30.3456 14.2941 25.7047 9.6532 20.0002 9.6532ZM20.0002 26.32C16.509 26.32 13.6788 23.4899 13.6788 19.9986C13.6788 16.5074 16.509 13.6772 20.0002 13.6772C23.4915 13.6772 26.3216 16.5074 26.3216 19.9986C26.3216 23.4898 23.4914 26.32 20.0002 26.32Z'
                    fill={`url(#${innerGradientId})`}
                />
                <path
                    d='M30.3633 12.2095C31.7324 12.2095 32.8422 11.0997 32.8422 9.73056C32.8422 8.36146 31.7324 7.25159 30.3633 7.25159C28.9942 7.25159 27.8843 8.36146 27.8843 9.73056C27.8843 11.0997 28.9942 12.2095 30.3633 12.2095Z'
                    fill={`url(#${dotGradientId})`}
                />
            </g>
            <defs>
                <linearGradient
                    id={outerGradientId}
                    x1='20'
                    y1='39.8836'
                    x2='20'
                    y2='0.310687'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#E09B3D' />
                    <stop offset='0.3' stopColor='#C74C4D' />
                    <stop offset='0.6' stopColor='#C21975' />
                    <stop offset='1' stopColor='#7024C4' />
                </linearGradient>
                <linearGradient
                    id={innerGradientId}
                    x1='20.0002'
                    y1='39.8822'
                    x2='20.0002'
                    y2='0.309312'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#E09B3D' />
                    <stop offset='0.3' stopColor='#C74C4D' />
                    <stop offset='0.6' stopColor='#C21975' />
                    <stop offset='1' stopColor='#7024C4' />
                </linearGradient>
                <linearGradient
                    id={dotGradientId}
                    x1='30.3632'
                    y1='39.8819'
                    x2='30.3632'
                    y2='0.309004'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#E09B3D' />
                    <stop offset='0.3' stopColor='#C74C4D' />
                    <stop offset='0.6' stopColor='#C21975' />
                    <stop offset='1' stopColor='#7024C4' />
                </linearGradient>
                <clipPath id={clipPathId}>
                    <rect width='40' height='40' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
}
